import { render } from "./ExpiredCompany.vue?vue&type=template&id=88b0d3be"
import script from "./ExpiredCompany.vue?vue&type=script&lang=js"
export * from "./ExpiredCompany.vue?vue&type=script&lang=js"

import "./ExpiredCompany.vue?vue&type=style&index=0&id=88b0d3be&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__